import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { isMockEnabled } from './utils/mockMode';

/**
 * MSWモックモードの初期化
 * 
 * URLクエリパラメータ `?mock=true` でモックモードが有効化されます。
 * 有効化後はsessionStorageに保存され、ブラウザを閉じるまで維持されます。
 */
async function enableMocking() {
  if (!isMockEnabled()) {
    return;
  }

  const { worker } = await import('./mocks/browser');
  
  return worker.start({
    onUnhandledRequest: 'error', // 未定義のリクエストはエラーとして扱う
    serviceWorker: {
      url: '/mockServiceWorker.js',
    },
  });
}

// モック初期化後にReactアプリをレンダリング
enableMocking().then(() => {
  const root = createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});